import { hasActiveDemoAccess } from "./demoAccess";

function feat(entitlements, key) {
  const f = entitlements?.features;
  if (!f) return false;
  if (key.startsWith("max_")) {
    const n = Number(f[key]);
    return Number.isFinite(n) && n > 0;
  }
  return Boolean(f[key]);
}

/** Доступные возможности текущего клуба (фичи приходят с API, в демо — «Максимальный»). */
export function resolvePlanAccess(entitlements, tenant, billing) {
  const demo = hasActiveDemoAccess(tenant, billing);
  const features = entitlements?.features;
  const planCode = entitlements?.plan?.code;

  const f = (key) => {
    if (demo) {
      const demoFull = [
        "chat",
        "club_life",
        "member_social",
        "competitions",
        "polls",
        "polls_advanced",
        "branding",
        "branding_lite",
        "splash_branding",
      ];
      if (demoFull.includes(key)) return true;
    }
    return feat(entitlements, key);
  };

  const limits = features || {};

  const standardPlan = ["basic", "pro", "business"].includes(planCode);
  const chatEnabled =
    demo ||
    !features ||
    standardPlan ||
    Boolean(features?.chat);

  const fullBrandingEnabled =
    demo ||
    !features ||
    planCode === "pro" ||
    planCode === "business" ||
    Boolean(features?.branding);

  const brandingLiteEnabled =
    demo ||
    !features ||
    fullBrandingEnabled ||
    Boolean(features?.branding_lite);

  return {
    demo,
    chat: chatEnabled,
    clubLife: f("club_life"),
    memberSocial: f("member_social"),
    analytics: f("analytics"),
    analyticsExport: f("analytics_export"),
    polls: f("polls"),
    pollsAdvanced: f("polls_advanced"),
    finance: f("finance"),
    onlineAcquiring: f("online_acquiring"),
    branding: fullBrandingEnabled,
    brandingLite: brandingLiteEnabled,
    splashBranding: f("splash_branding"),
    whiteLabel: f("white_label"),
    competitions: f("competitions"),
    trainerPortal: f("trainer_portal"),
    multiTrainer: f("multi_trainer"),
    adminRoles: f("admin_roles"),
    multiBranch: f("multi_branch"),
    prioritySupport: f("priority_support"),
    fullBranding: fullBrandingEnabled,
    showPortalBrandingTab: fullBrandingEnabled || brandingLiteEnabled,
    limits: {
      trainers: limits.max_trainers ?? 1,
      clients: limits.max_clients,
      directions: limits.max_directions,
      branches: limits.max_branches,
      clubs: limits.max_clubs,
    },
  };
}